module.exports = __webpack_public_path__ + "img/movable-arrow-down.0be7d16f.svg";